import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ReactComponent as Icon } from 'assets/icon/404.svg';
import './index.scss'

export interface Error404Props {}

const Error404 = ({}: React.PropsWithChildren<Error404Props>): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <div className="error-container">
        <div className="error-img">
          <Icon />
        </div>
        <div className="error-content">
          <h3>Ooops! You weren&apos;t supposed to see this.</h3>
          <div className="error-para">
            <p className="mb-0">The page you&apos;re looking for no longer exists.</p>
            <p className="mb-0">Return to the homepage and remember: you haven&apos;t seen anything.</p>
          </div>
          <Button type="primary" className="error-btn" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </div>
      </div>
    </>
  );
};

export default Error404;
